import {createSlice} from "@reduxjs/toolkit";

const initialStatesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  stateForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const statesSlice = createSlice({
  name: "states",
  initialState: initialStatesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getstateById
    stateFetched: (state, action) => {
      state.actionsLoading = false;
      state.stateForEdit = action.payload.stateForEdit;
      state.error = null;
    },
    // findstates
    statesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
	  state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createstate
    stateCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.state);
    },
    // updatestate
    stateUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.state.id) {
          return action.payload.state;
        }
        return entity;
      });
    },
    // deletestate
    stateDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletestates
    statesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // statesUpdateState
    statesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      const normalizedStatus = (status === 0 || status === '0' || status === 'active') ? 'active' : 'inactive';
      state.entities = (state.entities || []).map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = normalizedStatus;
        }
        return entity;
      });
    }
  }
});
